export const reinitializeLines = (canvas,reinitpath)=>{
    for (let i = 0; i < canvas._objects.length; i++) {
        let obj = canvas._objects[i];
        if (obj.name === 'line') {
            reinitpath({target: obj, state: true})
        }
    }
}